import columns from './columns.json';

export default {
  columns,
};
